
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import { FaInfoCircle } from "react-icons/fa";
import './Ordercart.css';
import axios from 'axios';
import { useParams } from "react-router-dom";
import Orderplaced from "./Orderplaced";
import { useLocation as useRouteLocation } from "react-router-dom";


// const Ordercart = ({ orderId }) => {
const Foodcartdata = ({ filteredDataProp = [] }) => {
    const [cartData, setCartData] = useState([]);

    const [selectedService, setSelectedService] = React.useState(null);

    const [showPopup, setShowPopup] = useState(false);
    const [serviceApplied, setServiceApplied] = useState(true); // initially applied
    const navigate = useNavigate();
    const [userId, setUserId] = useState(localStorage.getItem("userId") || 3);
    const [orderData, setOrderData] = useState(null);
    // const [cartItems, setCartItems] = useState([]);

    const [savedDetails, setSavedDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cartItems, setCartItems] = useState([]);
    const [quantities, setQuantities] = useState({});

    const [showPaymentData, setShowPaymentData] = useState(false);
    const [filteredData, setFilteredData] = useState(filteredDataProp);
    const [refresh, setRefresh] = useState(false);
    const [displayData, setDisplayData] = useState([]);
    const [gst, setGst] = useState(0);
    // const location = useLocation();
    const [applied, setApplied] = useState(false); // Track if coupon is applied
    const [appliedCoupon, setAppliedCoupon] = useState(null);

    const [isWalletChecked, setIsWalletChecked] = useState(false);
    const [isCashChecked, setIsCashChecked] = useState(false);
    const [isOnlineChecked, setIsOnlineChecked] = useState(false);
    const vendorId = Number(localStorage.getItem("vendorId") || 42);  // Ensure vendorId is a number

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");

    const routeLocation = useRouteLocation(); // this holds routing info like state
    const [serviceCharges, setServiceCharges] = useState("");
    const [showWalletOptions, setShowWalletOptions] = useState(false);
    const [selectedWalletType, setSelectedWalletType] = useState("");

    const [selectedPayment, setSelectedPayment] = useState(""); // "online" or "cod"

    const [subTotal, setSubTotal] = useState(0);
    const [gstTotal, setgstTotal] = useState(0);
    const [cgst, setCgst] = useState(0);
    const [sgst, setSgst] = useState(0);
    const [platformCharge, setPlatformCharge] = useState(0);
    // const [packingTotal, setPackingTotal] = useState(0);
    // const [grandTotal, setGrandTotal] = useState(0);
    const [gstData, setGstData] = useState(null);
    const [selectedOrderType, setSelectedOrderType] = useState("");
    const [packingTotal, setPackingTotal] = useState(0);
    // const [serviceCharges, setServiceCharges] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [dishDetails, setDishDetails] = useState([]);

    const paymentRef = useRef(null);

    // Replace the commented useEffect with this:
    useEffect(() => {
        // Only scroll if selectedOrderType is set AND it's not the initial load
        if (selectedOrderType && paymentRef.current) {
            paymentRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [selectedOrderType]);
    // ✅ SINGLE SOURCE OF TRUTH - Replace all your useEffects with this
    useEffect(() => {
        const fetchCartData = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const authToken = localStorage.getItem("authToken");

            if (!vendorId || !authToken) return;

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
                    {
                        headers: { Authorization: `Bearer ${authToken}` },
                    }
                );

                if (response.data) {
                    const data = response.data;
                    console.log("🔄 SINGLE SOURCE - Cart Data:", data);

                    // ✅ ALWAYS USE BACKEND CALCULATED VALUES - NO MANUAL MATH
                    setCartItems(data.cartItems || []);
                    setSubTotal(data.subtotal || 0);
                    setgstTotal(data.gstTotal || 0);
                    setPlatformCharge(data.platformCharges || 0);
                    setPackingTotal(data.packingTotal || 0); // Use backend packing total
                    setServiceCharges(data.serviceCharges || 0);
                    setGrandTotal(data.grandTotal || 0); // Use backend grandTotal

                    // Order type
                    // const orderTypeFromApi = data.orderType === "DINE_IN" ? "Dine In" : "Take Away";
                    // setSelectedOrderType(orderTypeFromApi);

                    // Service applied status
                    setServiceApplied(data.serviceCharges > 0);

                    // Save cartId
                    if (data.cartId) {
                        localStorage.setItem("cartId", data.cartId);
                    }

                    // Quantities
                    const updatedQuantities = (data.cartItems || []).reduce((acc, item) => {
                        acc[item.dishId] = item.quantity || 1;
                        return acc;
                    }, {});
                    setQuantities(updatedQuantities);
                }
            } catch (err) {
                console.error("❌ Error fetching cart data:", err);
            }
        };

        fetchCartData();
    }, [refresh]); // Only depend on refresh trigger
    // Function to fetch all dish details with packing charges
    const fetchAllDishDetails = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/menu/vendor/${vendorId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const dishes = response.data || [];
            console.log("📦 All Dish Details:", dishes);
            setDishDetails(dishes);
            return dishes;
        } catch (error) {
            console.error("Error fetching dish details:", error);
            return [];
        }
    };
    // Improved packing charges calculation

    const [totals, setTotals] = useState({
        subTotal: 0,
        cgst: 0,
        sgst: 0,
        platformCharges: 0,
        grandTotal: 0
    });
    const [phoneNumber, setPhoneNumber] = useState("");

    const containerHeight = window.innerWidth < 768
        ? '300px'       // Mobile
        : window.innerWidth < 850
            ? '300px'     // Below 850px
            : window.innerWidth < 1400
                ? '405px'   // Between 850px and 1399px
                : window.innerWidth < 1600
                    ? '590px' // Between 1400px and 1599px
                    : '640px'; // Above 1600px
    const handleOrderTypeChange = async (type) => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Vendor not logged in!");
            return;
        }

        setLoading(true);
        try {
            const orderTypeValue = type === "Dine In" ? "DINE_IN" : "TAKEAWAY";

            await axios.put(
                `https://backend.maamaas.com/food/api/cart/update/orderType/${vendorId}?orderType=${orderTypeValue}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setSelectedOrderType(type);

            // ✅ Refresh all data from backend
            setRefresh(prev => prev + 1);

        } catch (error) {
            console.error("❌ Error updating order type:", error);
            alert("Failed to update order type. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const toggleServiceCharges = async (cartId) => {
        if (selectedOrderType === "Take Away") {
            alert("Service charges are not applicable for Take Away orders.");
            return;
        }

        if (!cartId) {
            alert("Cart ID is missing");
            return;
        }

        const token = localStorage.getItem("authToken");
        const newStatus = serviceApplied ? "NOT_APPLICABLE" : "APPLICABLE";

        try {
            setLoading(true);

            await axios.put(
                `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
                { serviceCharge: newStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // ✅ Refresh all data from backend
            setRefresh(prev => prev + 1);

        } catch (error) {
            console.error("API ERROR:", error);
            alert("Failed to update service charges. Try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleShowGST = async (vendorId) => {
        // fallback to localStorage if nothing is passed
        const currentVendorId = vendorId || localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/${currentVendorId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // if required
                    },
                }
            );
            const data = response.data;
            // ✅ Handle both array and object response cases 
            const gstObj = Array.isArray(data) ? data[0] : data;

            if (gstObj) {
                const gstDetails = {
                    serviceChargeGst: gstObj.serviceChargeGst ?? 0,
                    platformChargeGst: gstObj.platformChargeGst ?? 0,
                    packingChargeGst: gstObj.packingChargeGst ?? 0,
                    cgst: gstObj.cgst ?? 0,
                    sgst: gstObj.sgst ?? 0,
                    gstTotal: gstObj.gstTotal ?? 0,   // 👈 added total if you want to show
                    grandTotal: gstObj.grandTotal ?? 0,
                };

                console.table(gstDetails);

                setGstData(gstDetails);
                setShowPopup(true);
            } else {
                // console.warn("No GST data found in API response.");
            }
        } catch (err) {
            // console.error("Error fetching GST data:", err);
        }
    };

    const handleCheckoutClickS = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!userId) {
            alert("User ID not found. Please log in again.");
            return;
        }

        if (selectedPaymentMethod === "Maamaas_Wallet" && !selectedWalletType) {
            alert("Please select a wallet type before creating the order.");
            return;
        }

        try {
            localStorage.removeItem("orderId"); // Clear any previous order
            const storedCoupon = localStorage.getItem("appliedCoupon");
            const appliedCoupon = storedCoupon ? JSON.parse(storedCoupon) : null;

            // 🔹 ONLINE PAYMENT FLOW
            if (selectedPaymentMethod === "Online_Payment") {
                try {
                    const isRazorpayLoaded = await loadRazorpayScript();
                    if (!isRazorpayLoaded) {
                        alert("❌ Razorpay SDK failed to load.");
                        setLoading(false);
                        return;
                    }

                    const amountInPaise = Math.round(grandTotal * 100);
                    const displayAmount = amountInPaise / 100; // ₹130


                    // 🔹 Step 1: Create Razorpay Order via backend all the backed data of the api/paymnets/create-order not fetching in it 
                    const orderResponse = await fetch(
                        "https://backend.maamaas.com/food/api/payments/create-order",
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify({
                                amount: displayAmount,
                                phoneNumber: "9745896321", // default number
                                currency: "INR",
                                receipt: `order_${Date.now()}`,
                                notes: {
                                    customer_name: savedDetails?.name || "John Doe",
                                    order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
                                },
                            }),

                        }
                    );

                    if (!orderResponse.ok) throw new Error("❌ Failed to create Razorpay order");
                    const orderData = await orderResponse.json();

                    // 🔹 Step 2: Open Razorpay Checkout
                    const options = {
                        key: "rzp_live_RU5whSMu9rPV7s",
                        amount: amountInPaise,
                        currency: "INR",
                        order_id: orderData.orderId,
                        name: "Maamaa's House",
                        description: "Order Payment",
                        prefill: {
                            name: savedDetails?.name || "vamshi",
                            email: savedDetails?.email || "vamshikvky500@gmail.com",
                            contact: savedDetails?.mobileNumber || "9652030425",
                        },
                        theme: { color: "#3399cc" },

                        handler: async function (response) {
                            try {

                                // 🔹 Capture payment payload
                                const capturePayload = {
                                    paymentId: response.razorpay_payment_id,
                                    amount: amountInPaise / 100,
                                    currency: "INR",
                                    receipt: `receipt_${Date.now()}`, // unique receipt
                                };


                                // 🔹 Call capture API
                                const captureRes = await fetch(
                                    "https://backend.maamaas.com/food/api/payments/capture",
                                    {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            Authorization: `Bearer ${token}`,
                                        },
                                        body: JSON.stringify(capturePayload),
                                    }
                                );

                                // 🔹 Parse capture response
                                const captureData = await captureRes.json();

                                if (!captureRes.ok || captureData.status !== "captured") {
                                    alert("❌ Payment capture failed!");
                                    return;
                                }

                                // 🔹 Backend order creation — send exact IDs
                                const backendOrderParams = {
                                    vendorId: vendorId,
                                    paymentMethod: "Online_Payment",
                                    razorpayPaymentId: response.razorpay_payment_id,
                                    razorpayOrderId: 1, // use captured order ID
                                    phoneNumber: savedDetails?.mobileNumber || "8688037081",
                                };
                                const responseOrder = await axios.post(
                                    `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${localStorage.getItem(
                                        "cartId"
                                    )}`,
                                    "", // empty body
                                    {
                                        params: backendOrderParams,
                                        headers: { Authorization: `Bearer ${token}` },
                                        validateStatus: false,
                                    }
                                );
                                if (responseOrder.status === 200 || responseOrder.status === 201) {
                                    localStorage.setItem("orderId", responseOrder.data.orderId);
                                    // alert("✅ Payment captured and order placed successfully!");
                                    setShowPaymentData(true);
                                } else {
                                    // console.error("❌ Order creation failed after payment!", responseOrder.data);
                                    alert("❌ Order creation failed after payment!");
                                }

                            } catch (err) {
                                // console.error("❌ Error in payment handler:", err);
                                alert("❌ Something went wrong after payment.");
                            }
                        },
                    };
                    const paymentObject = new window.Razorpay(options);
                    paymentObject.open();
                    return;
                } catch (err) {
                    // console.error("❌ Razorpay flow error:", err);
                    alert("❌ Razorpay flow failed.");
                    setLoading(false);
                    return;
                }
            }

            // 🔹 OTHER PAYMENT METHODS (COD / Wallet)
            const orderResponse = await axios.post(
                `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${localStorage.getItem("cartId")}`,
                null,
                {
                    params: {
                        vendorId,
                        cartId: localStorage.getItem("cartId"),
                        paymentMethod: selectedPaymentMethod,
                        phoneNumber: "8688037081",
                        razorpayPaymentId: "N/A",
                        razorpayOrderId: "N/A",
                        couponCode: appliedCoupon?.code || "",
                        couponId: appliedCoupon?.id || null,
                    },
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            if (orderResponse.status === 200 || orderResponse.status === 201) {
                // alert("✅ Order created successfully!");
                if (orderResponse.data && orderResponse.data.orderId) {
                    localStorage.setItem("orderId", orderResponse.data.orderId);
                }
                navigate("/foodAccuontdata");
            } else {
                alert("⚠️ Failed to create order.");
            }
        } catch (error) {
            // console.error("API error:", error);
            alert("Failed to proceed to checkout.");
        }
    };

    useEffect(() => {
        const flag = localStorage.getItem("showPaymentData") === "true";
        const service = localStorage.getItem("selectedService");
        const order = localStorage.getItem("orderData");

        if (flag && service && order) {
            setShowPaymentData(true);
            setSelectedService(service);
            setOrderData(JSON.parse(order));
        }
        // Optional: Clear after use
        localStorage.removeItem("showPaymentData");
        localStorage.removeItem("selectedService");
        localStorage.removeItem("orderData");
    }, []);
    useEffect(() => {
        const storedCoupon = JSON.parse(localStorage.getItem("couponData"));
        if (storedCoupon) {
            setAppliedCoupon(storedCoupon);
            setApplied(true);
        }
    }, []);

    React.useEffect(() => {
        const service = localStorage.getItem('selectedService');
        setSelectedService(service);
    }, []);

    const handleCheckboxChange = (e, method, type) => {
        const isChecked = e.target.checked;
        // Reset all payment type states first
        setIsWalletChecked(false);
        setIsCashChecked(false);
        setIsOnlineChecked(false);
        setShowWalletOptions(false);

        let newSelectedMethod = "";

        if (isChecked) {
            switch (method) {
                case "wallet":
                    setIsWalletChecked(true);
                    setShowWalletOptions(true); // Show wallet options
                    newSelectedMethod = "Maamaas_Wallet";
                    break;
                case "cash":
                    setIsCashChecked(true);
                    newSelectedMethod = "Cash";
                    break;
                case "online":
                    setIsOnlineChecked(true);
                    newSelectedMethod = "Online_Payment";
                    break;
                default:
                    break;
            }
            // ✅ Set selectedPayment to the passed type when checked
            setSelectedPayment(type);
        } else {
            // Unchecking resets selectedPayment
            setSelectedPayment("");
        }

        // Update the main payment method state
        setSelectedPaymentMethod(newSelectedMethod);
    };

    useEffect(() => {
        setDisplayData(filteredDataProp);
    }, [filteredDataProp]);
    useEffect(() => {
        const updateData = () => {
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            if (filteredDataProp && Array.isArray(filteredDataProp) && filteredDataProp.length > 0) {
                setFilteredData(filteredDataProp);

                // Save only if not already stored (prevent quota issues)
                const currentStored = localStorage.getItem("cartItems");
                const newData = JSON.stringify(filteredDataProp);

                if (currentStored !== newData) {
                    try {
                        localStorage.setItem("cartItems", newData);
                    } catch (e) {
                        console.warn("🛑 Storage quota exceeded, not saving cartItems.");
                    }
                }
            }
        };
        updateData();
        const interval = setInterval(() => {
            setRefresh(prev => prev + 1);
            updateData();
        }, 1000000); // ⬆ increased to 1000ms to avoid flooding

        return () => clearInterval(interval);
    }, [filteredDataProp, refresh]);


    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    useEffect(() => {
        const storedOrderData = localStorage.getItem("orderData");
        const storedShowCheckout = localStorage.getItem("showCheckout");

        if (storedOrderData && storedShowCheckout === "true") {
            setOrderData(JSON.parse(storedOrderData));
            // setShowCheckout(true);

            // ✅ Clear `showCheckout` after showing it once
            localStorage.removeItem("showCheckout");
        }
    }, []);
    cartItems.reduce((acc, item) => ({ ...acc, [item.dishId]: item.quantity || 1 }), {})

    const incrementQuantity = async (item) => {
        const cartId = item?.cartId || localStorage.getItem("cartId");
        const itemId = item?.itemId;
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!cartId || !itemId || !vendorId) return;

        const currentQty = quantities[itemId] || item.quantity || 1;
        const newQuantity = currentQty + 1;

        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?itemId=${itemId}&quantity=${newQuantity}`;

        try {
            await axios.put(apiUrl, null, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                    accept: "*/*",
                },
            });

            // ✅ ONLY REFRESH DATA - NO MANUAL CALCULATIONS
            setRefresh(prev => prev + 1); // This triggers the single useEffect

        } catch (err) {
            console.error("❌ Error updating quantity:", err);
        }
    };

    const decrementQuantity = async (item) => {
        const cartId = item?.cartId || localStorage.getItem("cartId");
        const itemId = item?.itemId;
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!cartId || !itemId || !vendorId) return;

        const currentQty = quantities[itemId] || item.quantity || 1;
        const newQuantity = currentQty - 1;

        if (newQuantity < 1) return;

        const updateUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?itemId=${itemId}&quantity=${newQuantity}`;

        try {
            await axios.put(updateUrl, {}, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                    "Content-Type": "application/json",
                },
            });

            // ✅ ONLY REFRESH DATA - NO MANUAL CALCULATIONS
            setRefresh(prev => prev + 1); // This triggers the single useEffect

        } catch (err) {
            console.error("❌ Error updating quantity:", err);
        }
    };
    useEffect(() => {
        setDisplayData(cartItems);
    }, [cartItems]);

    useEffect(() => {
        loadCart();

        const savedQuantities = localStorage.getItem("cartQuantities");
        if (savedQuantities) {
            setQuantities(JSON.parse(savedQuantities));
        }
    }, []);

    // ✅ This runs once to load initial cart
    const loadCart = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken"); // ✅ fetch from localStorage

        if (!vendorId) {
            // console.error("🚨 Vendor ID not found in localStorage!");
            setCartItems([]); // reset if no vendor
            return;
        }

        if (!authToken) {
            // console.error("🚨 Auth Token not found in localStorage!");
            setCartItems([]); // reset if no token
            return;
        }

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${authToken}`, // ✅ attach token
                        "Cache-Control": "no-cache"
                    }
                }
            );

            const items = response.data?.cartItems || [];

            // ✅ Always set the latest data
            setCartItems(items);

            // ✅ Rebuild quantities fresh from API
            const updatedQuantities = items.reduce((acc, item) => {
                const dishId = item.dishId || item.id;
                acc[dishId] = item.quantity ?? item.qty ?? 1;
                return acc;
            }, {});

            setQuantities(updatedQuantities);

            // ✅ Persist only after fresh update
            localStorage.setItem("cartQuantities", JSON.stringify(updatedQuantities));

        } catch (error) {
            // console.error("❌ Error fetching cart data:", error);
            setCartItems([]); // fallback to empty cart
        }
    };

    // Refresh can just call loadCart again
    const refreshData = async () => {
        await loadCart();
    };

    const handleClearCart = async (cartId) => {
        try {
            const vendorId = localStorage.getItem("vendorId");
            const authToken = localStorage.getItem("authToken");

            if (!vendorId) {
                alert("Vendor ID not found!");
                return;
            }

            if (!cartId) {
                alert("Cart ID not found!");
                return;
            }

            if (!authToken) {
                alert("Authentication token not found!");
                return;
            }

            const response = await fetch(
                `https://backend.maamaas.com/food/api/cart/delete/${vendorId}/${cartId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${authToken}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            alert("🗑️ Cart cleared successfully!");

            // ✅ RESET ALL CALCULATION STATES
            setDisplayData([]);
            setCartItems([]);
            setSubTotal(0);
            setgstTotal(0);
            setPlatformCharge(0);
            setPackingTotal(0);
            setServiceCharges(0);
            setGrandTotal(0);

            // ✅ RESET ORDER TYPE
            setSelectedOrderType("");
            localStorage.removeItem("userSelectedOrderType");

            // ✅ RESET QUANTITIES
            setQuantities({});
            localStorage.removeItem("cartQuantities");

        } catch (error) {
            console.error("Failed to clear cart:", error);
            alert("Failed to clear the cart. Please try again!");
        }
    };
    const [offers, setOffers] = useState([]);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 480);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div>
            {!showPaymentData ? (
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    {/* Button Section */}
                    {/* ===================  check Out code ============================================== */}
                    <div
                        style={{
                            overflowY: isMobile ? "none" : "auto",
                            scrollbarWidth: "none",
                            marginTop: "-50px",
                            height: containerHeight,
                        }}
                        className="carts1 "
                    >
                        <>
                            <div>
                                <>
                                    <style>{`
        .order-wrapper {
          display: flex;
          flex-direction: column;
        //   padding: 5px;
           background: #b15cd6;
          font-family: sans-serif;
         border-radius: 10px;
         margin-top:10px;
        }

        .order-container {
          background: #b15cd6;
          border-radius: 10px;
          color: #fff;
          padding: 15px;
          margin-bottom: 20px;
        }

        .order-heading {
          font-weight: bold;
          text-align: center;
          font-size: 22px;
          margin-bottom: 15px;
        }

        .order-table-wrapper {
          overflow-x: auto;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 15px;
          font-weight: bold;
        }

        th, td {
          padding: 10px;
          border-bottom: 1px solid #fff;
          text-align: center;
          font-size: 18px;
        }


@media (max-width: 480px) {
  th, td {
    font-size: 10px;
  }
}


        .quantity-box {
          display: flex;
          align-items: center;
          background: #fff;
          border-radius: 10px;
          width: 80px;
          margin: auto;
        }

        .quantity-box button {
          border: none;
          background: transparent;
          padding: 5px;
          cursor: pointer;
          color: #000;
          font-weight: bold;
          font-size:16px;
        }

        .quantity-box span {
          padding: 0 10px;
          font-weight: 800;
          color: #000;
        }

        .no-data {
          text-align: center;
          padding: 20px;
          font-weight: bold;
        }

        .total-section {
          background: #b15cd6;
          border-radius: 10px;
          padding: 20px;
          color: white;
        }

        .pricedetails {
          display: flex;
        //   align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        //   flex-wrap: wrap;
        }

        .pricedetails dt,
        .pricedetails dd {
          margin: 0;
          font-size:19px;
        }

        .pricedetails dd {
          min-width: 50px;
          text-align: right;
        }

        .total-button {
          padding: 4px 10px;
          width: 85px;
          height: 35px;
          cursor: pointer;
          border: none;
          border-radius: 10px;
          color: white;
          font-weight: bold;
        }

        hr {
          border: 2px solid #000 !important;
          margin: 15px 0;
        }

        @media (max-width: 1200px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
        }

        @media (max-width: 768px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
            .clear-cart-data-size{
            font-size: 13px !important;
            }
            .cart-title-data{
            font-size: 20px !important;
            }
        }
      `}</style>
                                    <div className="order-wrapper">
                                        {/* Order Items Table */}
                                        <div className="order-container">
                                            <div style={{ position: "relative", textAlign: "center", marginBottom: "16px" }}>
                                                <h4 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }} className="cart-title-data">Review your Cart</h4>
                                                <button
                                                    onClick={() => handleClearCart(localStorage.getItem("cartId"))}
                                                    style={{
                                                        position: "absolute",
                                                        right: "0",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        color: "red",
                                                        background: "#fff",
                                                        border: "none",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                        fontSize: "18px",
                                                    }}
                                                    className="clear-cart-data-size"
                                                >
                                                    Clear All
                                                </button>
                                            </div>
                                            <div className="order-table-wrapper">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>S.NO</th>
                                                            <th>ITEM</th>
                                                            <th>QUANTITY</th>
                                                            <th>PRICE</th>
                                                            <th>TOTAL</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {displayData.length > 0 ? (
                                                            displayData
                                                                .filter((item) => (quantities[item.dishId] ?? item.quantity ?? 1) > 0) // 👈 only show items with qty > 0
                                                                .map((item, index) => (
                                                                    <tr
                                                                        key={item.cartItemId}
                                                                        style={{ textAlign: "center", verticalAlign: "middle" }}
                                                                    >
                                                                        <td>{index + 1}</td>
                                                                        <td style={{ fontWeight: "bold" }}>{item.dishName}</td>
                                                                        <td>
                                                                            <div className="quantity-box">
                                                                                <button
                                                                                    className="qty-btn"
                                                                                    onClick={() => decrementQuantity(item)}
                                                                                >
                                                                                    -
                                                                                </button>
                                                                                <span className="qty-value">
                                                                                    {quantities[item.dishId] ?? item.quantity ?? 1}
                                                                                </span>
                                                                                <button
                                                                                    className="qty-btn"
                                                                                    onClick={() => incrementQuantity(item)}
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                        <td>₹{item.price?.toFixed(2)}</td>
                                                                        <td>₹{item.totalPrice.toFixed(2)}</td>
                                                                    </tr>
                                                                ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="no-data">
                                                                    No data available
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                        <hr />
                                        {/* Total Pricing Summary */}
                                        <div className="total-section">
                                            <dl>
                                                <div className="pricedetails">
                                                    <dt>Sub Total</dt>
                                                    <dd>₹{subTotal}</dd>
                                                </div>
                                                <div className="pricedetails">
                                                    <dt>Platform Charges</dt>
                                                    <dd>₹{platformCharge}</dd>
                                                </div>
                                                <div className="pricedetails">
                                                    <dt>Packing Charges</dt>
                                                    <dd>₹{packingTotal}</dd>  {/* This should show ₹1 */}
                                                </div>
                                                <div className="pricedetails">
                                                    <dt
                                                        onClick={() => {
                                                            const cartId = localStorage.getItem("cartId");
                                                            toggleServiceCharges(cartId);
                                                        }}
                                                        style={{
                                                            cursor: "pointer",
                                                            padding: "4px 8px",
                                                            borderRadius: "5px",
                                                            border: "1px solid #ccc",
                                                            background: "rgb(242, 242, 242)",
                                                            fontWeight: "bold",
                                                            color: "#000",
                                                            fontSize: "15px",
                                                        }}
                                                    >
                                                        Service Charges {serviceApplied ? "(Remove)" : "(Apply)"}
                                                    </dt>



                                                    <dd>₹{serviceCharges}</dd>
                                                </div>


                                                <div className="pricedetails">
                                                    <dt>GST   <FaInfoCircle
                                                        style={{ marginLeft: "8px", cursor: "pointer", color: "rgb(0 187 90)" }}
                                                        onClick={() => handleShowGST(vendorId)}
                                                    /></dt>
                                                    <dd>₹{gstTotal}</dd>
                                                </div>
                                                <hr />

                                                <div className="pricedetails" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    <dt>Grand Total</dt>
                                                    <dd>₹{grandTotal.toFixed(2)}</dd>

                                                </div>
                                            </dl>
                                        </div>
                                    </div>
                                </>
                            </div>
                            {/* Internal CSS */}
                            <style>{`
        .payment-container {
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }

        .primary-btn {
            padding: 10px 20px;
            background-color: #b15dc6;
            color: #fff;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            width: 150px;
            font-weight: bold;
            font-size: 20px;
        }

        .payment-options {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 30px;
        }

        .payment-options button {
            padding: 10px 20px;
            border: none;
            border-radius: 5px;
            width: 140px;
            font-weight: bold;
            font-size: 20px;
            cursor: pointer;
        }

        .pay-now {
            background-color: #4CAF50;
            color: #fff;
        }

        .pay-later {
            background-color: #f44336;
            color: #fff;
        }

        .method-box-container {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 20px;
            margin-top: 40px;
        }

        .method-box {
            flex: 1;
            min-width: 250px;
            max-width: 30%;
            
            background: rgb(177, 93, 198);
            border-radius: 10px;
            display: flex;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
        }

        .method-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .method-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-balance-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-container {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #b15cd6;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: 10px;
            margin-bottom: 20px;
            padding: 0 30px;
        }

        /* Responsive for smaller screens */
        @media (max-width: 768px) {
            .method-box {
                max-width: 100%;
            }

            .payment-options {
                flex-direction: column;
                align-items: center;
                gap: 15px;
            }
        }
    `}</style>
                        </>
                        <style>{`

        .payment-box {
            flex: 1;
            min-width: 250px;
            max-width: 30%;
            height: 60px;
            background: rgb(177, 93, 198);
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: start;
            padding: 0 20px;
            box-sizing: border-box;
        }

        .payment-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .payment-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-amount-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-wrapper {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #b15cd6;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: -30px;
            margin-bottom: 20px;
            padding: 0 30px;
        }

        @media (max-width: 968px) {
          
                  .payment-row {
            display: flex;
            justify-content: center;
            gap: 20px;
       
            flex-wrap: wrap;
        }
        }
          @media (min-width: 968px) {
       
                  .payment-row {
            display: flex;
            justify-content: center;
            gap: 20px;
       margin-top: 20px !important;
            flex-wrap: wrap;
        }
        }
    `}</style>
                        <div className="row">


                            {/* Payment Section */}
                            {/* {selectedOrderType && ( */}
                            <div ref={paymentRef}>
                                <div className="payment-row">
                                    <div className="payment-box">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => handleCheckboxChange(e, "cash")}
                                            checked={isCashChecked}
                                        />
                                        <h3>Cash</h3>
                                    </div>

                                    <div>
                                        <div className="payment-box">
                                            <input
                                                type="checkbox"
                                                onChange={(e) => handleCheckboxChange(e, "online", "online")}
                                                checked={selectedPayment === "online"}
                                            />
                                            <h3>Online Payment</h3>
                                        </div>

                                        {/* Conditionally render phone number input */}

                                    </div>
                                </div>
                                <div className="checkout-wrapper" style={{ marginTop: "50px" }}>
                                    <button className="checkout-btn" onClick={handleCheckoutClickS}>
                                        Proceed to CheckOut
                                    </button>
                                </div>
                            </div>
                            {/* )} */}
                        </div>
                    </div >
                    {/* ===================================== GST POP UP DATA =============================================================== */}
                    {showPopup && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: "rgba(0, 0, 0, 0.6)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 999,
                                animation: "fadeIn 0.3s ease-in-out",
                            }}
                        >
                            <div
                                style={{
                                    background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
                                    padding: "25px",
                                    borderRadius: "12px",
                                    width: "350px",
                                    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                                    textAlign: "center",
                                    animation: "scaleUp 0.3s ease-in-out",
                                }}
                            >
                                <h3 style={{ marginBottom: "15px", color: "#333", fontSize: "20px" }}>
                                    GST Breakdown
                                </h3>

                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>Service Charge GST:</strong> ₹{gstData.serviceChargeGst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>Platform Charge GST:</strong> ₹{gstData.platformChargeGst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>Packing Charge GST:</strong> ₹{gstData.packingChargeGst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>CGST:</strong> ₹{gstData.cgst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>SGST:</strong> ₹{gstData.
                                            sgst
                                        }
                                    </li>
                                </ul>

                                <button
                                    onClick={() => setShowPopup(false)}
                                    style={{
                                        marginTop: "20px",
                                        padding: "10px 18px",
                                        background: "linear-gradient(90deg, #007bff, #0056d2)",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                    }}
                                    onMouseOver={(e) =>
                                    (e.target.style.background =
                                        "linear-gradient(90deg, #0056d2, #003c99)")
                                    }
                                    onMouseOut={(e) =>
                                    (e.target.style.background =
                                        "linear-gradient(90deg, #007bff, #0056d2)")
                                    }
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div >
            ) : (
                <Orderplaced />
            )
            }
            {/* Add this debug section temporarily */}


        </div >

    );
};

export default Foodcartdata;





